import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo, useRef } from 'react';
import PagePlaceholder from './PagePlaceholder.js';
import { usePDFContent } from './PDF.js';
import { styled } from 'styled-components';
import { SPAN } from '@fabric-app/ui/components/Typography';
import { useInViewWithinRadixScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { cssVar } from '@fabric-app/ui/theme/variables';

const Wrapper = styled.div.withConfig({
  displayName: "TinyPage__Wrapper",
  componentId: "sc-c1b6982f-0"
})([
  `display:flex;flex-direction:column;gap:7px;align-items:center;position:relative;> span{font-weight:600;font-size:12px;line-height:15px;}`
]);
const ThumbnailWrapper = styled.div.withConfig({
  displayName: "TinyPage__ThumbnailWrapper",
  componentId: "sc-c1b6982f-1"
})([
  `cursor:pointer;border-radius:10px;box-sizing:border-box;overflow:hidden;position:relative;> *{border-radius:4px;overflow:hidden;}&[data-active='true']{outline:4px solid #93b3f2;}&:not([data-active='true']){&::before{display:block;content:'';position:absolute;inset:0;background-color:rgba(0,0,0,0.05);transition:0.2s opacity;}&:hover{&::before{opacity:0;}outline:4px solid `,
  `;}}`
], cssVar["color-border-secondary"]);
const TinyPage = ({ pageNumber, width, onClick = () => {
} }) => {
  const { getEstimatedHeight, currentPage } = usePDFContent();
  const active = useMemo(() => pageNumber === currentPage, [
    pageNumber,
    currentPage
  ]);
  const height = useMemo(() => getEstimatedHeight(pageNumber, width, true), [
    getEstimatedHeight,
    pageNumber,
    width
  ]);
  const containerRef = useRef(null);
  const isInView = useInViewWithinRadixScrollArea(containerRef);
  return /* @__PURE__ */ jsx("div", {
    "aria-current": active,
    "aria-label": `Page ${pageNumber}`,
    role: "button",
    "data-page": pageNumber,
    ref: containerRef,
    children: /* @__PURE__ */ jsxs(Wrapper, {
      children: [
        !isInView ? /* @__PURE__ */ jsx("div", {
          style: {
            width,
            height
          }
        }) : /* @__PURE__ */ jsx(ThumbnailWrapper, {
          onClick,
          "data-active": active,
          style: {
            width,
            height
          },
          children: /* @__PURE__ */ jsx(PagePlaceholder, {
            pageNumber,
            smallSpinner: true
          })
        }),
        /* @__PURE__ */ jsx(SPAN, {
          size: "sm",
          children: pageNumber
        })
      ]
    })
  });
};

export { TinyPage as default };
//# sourceMappingURL=TinyPage.js.map
